<template>
    <v-container fluid v-if="this.$store.state.signedIn">
        <v-flex xs12 class="px-4 py-4">
            <v-card>
                <OldRules></OldRules>
                <v-toolbar dark flat color="secondary">
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        {{ organisation }} AS Groups
                    </v-toolbar-title>
                    <v-progress-circular v-if="loading" indeterminate color="white"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <downloadcsv
                        class   = "btn btn-default"
                        :data   = "orgASGroups"
                        name = "orgASGroups.csv">
                        <v-tooltip top eager color="primary" id="exit-app">
                            <template v-slot:activator="{ on }">
                                <v-btn small dark v-on="on" color="success"> <v-icon>save_alt</v-icon> Org. AS Groups </v-btn>
                            </template>
                            <span :style="$store.state.textFormatting.main">CSV of organisation AS Groups</span>
                        </v-tooltip>        
                    </downloadcsv>
                    <v-btn @click="clickGroup('Click here to add group', 'organisation')" color="success" > Add group <v-icon>add</v-icon></v-btn>
                    <info>
                        <template slot>
                            Organisation AS Groups
                        </template>
                        <template slot="body">
                            <p> 
                                Create AS Groups to manipulate the way in which alerts are created for ASNs within the group. Choose from one of the following settings for the group:
                                <ul>
                                    <li><b>EXCLUDE:</b> Ownership assertions between ASNs in the group will <b>not create alerts</b> e.g. if I have AS 1 and AS 2 in a group and AS 2 asserts ownership over one of AS 1's prefixes, I will not be alerted </li>
                                    <li><b>HIJACK:</b> Ownership assertions between ASNs in the group will have their hijack scores overriden and set to the user defined score </li>
                                </ul>
                                Add ASNs to the group via the '<b>Edit ASNs</b>' page
                            </p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card-text>
                    <v-data-table  v-if="showOrgGroups && !loading" 
                    :headers="ASGroupHeaders" :items="orgASGroups" :key="id"
                    :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination"
                    >    
                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip top eager>
                            <span :style="$store.state.textFormatting.main" slot="activator">
                                {{ props.header.text }}
                            </span>
                            <span :style="$store.state.textFormatting.main">
                                {{ props.header.ad_text }}
                            </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td :style="$store.state.textFormatting.main"> {{props.item.group_name}} </td>
                                <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.exclude_hij }}</td>
                                <td :style="$store.state.textFormatting.main" class="text-xs-center">
                                    <span v-if="props.item.exclude_hij=='Hijack'">{{ props.item.hijack_setting }}</span>
                                    <span v-if="props.item.exclude_hij=='Exclude'">N/A</span>
                                </td>
                                <td :style="$store.state.textFormatting.main" class="text-xs-center">
                                    <v-icon small class="mr-2" @click="clickGroup(props.item, 'organisation')"> edit </v-icon>
                                    <v-icon small class="mr-2" @click="prepRemoveGroup(props.item, 'organisation')"> delete </v-icon>
                                </td>
                            </tr>
                        </template>
                        <template slot="no-data">
                            <v-alert :value="true" color="success" icon="warning">
                            No organisation AS Groups - add one with the 'Add Group' button
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <br />
        </v-flex>

        <v-flex xs12 class="px-4 py-4">
            <v-card>
                <v-toolbar dark flat color="secondary">
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        {{ username }} AS Groups
                    </v-toolbar-title>
                    <v-progress-circular v-if="loading" indeterminate color="white"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <downloadcsv
                        class   = "btn btn-default"
                        :data   = "userASGroups"
                        name = "userASGroups.csv">
                        <v-tooltip top eager color="primary" id="exit-app">
                            <template v-slot:activator="{ on }">
                                <v-btn small dark v-on="on" color="success"> <v-icon>save_alt</v-icon> User AS Groups </v-btn>
                            </template>
                            <span :style="$store.state.textFormatting.main">CSV of user AS Groups</span>
                        </v-tooltip>        
                    </downloadcsv>
                    <v-btn @click="clickGroup('Click here to add group', 'user')" color="success" > Add group <v-icon>add</v-icon></v-btn>
                    <info>
                        <template slot>
                            User AS Groups
                        </template>
                        <template slot="body">
                            <p> 
                                Create AS Groups to manipulate the way in which alerts are created for ASNs within the group. Choose from one of the following settings for the group:
                                <ul>
                                    <li><b>EXCLUDE:</b> Ownership assertions between ASNs in the group will <b>not create alerts</b> e.g. if I have AS 1 and AS 2 in a group and AS 2 asserts ownership over one of AS 1's prefixes, I will not be alerted </li>
                                    <li><b>HIJACK:</b> Ownership assertions between ASNs in the group will have their hijack scores overriden and set to the user defined score </li>
                                </ul>
                                Add ASNs to the group via the '<b>Edit ASNs</b>' page
                            </p>
                        </template>
                    </info>
                </v-toolbar>
                <v-card-text>
                    <v-data-table  v-if="showUserGroups && !loading2" 
                    :headers="ASGroupHeaders" :items="userASGroups" :key="id"
                    :rows-per-page-items="rowsPerPageItems2" :pagination.sync="pagination2"
                    >    
                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip top eager>
                            <span :style="$store.state.textFormatting.main" slot="activator">
                                {{ props.header.text }}
                            </span>
                            <span :style="$store.state.textFormatting.main">
                                {{ props.header.ad_text }}
                            </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td :style="$store.state.textFormatting.main"> {{props.item.group_name}} </td>
                                <td :style="$store.state.textFormatting.main" class="text-xs-center"> {{ props.item.exclude_hij }}</td>
                                <td :style="$store.state.textFormatting.main" class="text-xs-center">
                                    <span v-if="props.item.exclude_hij=='Hijack'">{{ props.item.hijack_setting }}</span>
                                    <span v-if="props.item.exclude_hij=='Exclude'">N/A</span>
                                </td>
                                <td :style="$store.state.textFormatting.main" class="text-xs-center">
                                    <v-icon small class="mr-2" @click="clickGroup(props.item, 'user')"> edit </v-icon>
                                    <v-icon small class="mr-2" @click="prepRemoveGroup(props.item, 'user')"> delete </v-icon>
                                </td>
                            </tr>
                        </template>
                        <template slot="no-data">
                            <v-alert :value="true" color="success" icon="warning">
                            No user AS Groups - add one with the 'Add Group' button
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <br />
        </v-flex>

        <v-flex xs12 v-if="displayMessage">
            <v-card class="justify-right" :color="msgColor">
                <h3> {{ message }} </h3>
            </v-card>
        </v-flex>

        <v-layout wrap justify-center>
            <v-flex xs12 md10 v-if="showEdit">
                <v-card>
                    <v-toolbar flat dark color="primary">
                        <v-toolbar-title v-if="edType == 'Add'">Add AS Group to your {{ addType }} </v-toolbar-title>
                        <v-toolbar-title v-if="edType == 'Edit'">Edit selected AS Group </v-toolbar-title>
                        

                        <v-spacer></v-spacer>

                        <v-btn color="success" class="mr-4" @click="editASGroup" :disabled="!valid"> Submit </v-btn>
                        <v-btn class="mx-2" fab small color="blue" @click="showEdit=false">
                            <h3>-</h3>
                        </v-btn>

                    </v-toolbar>

                    <v-container fluid>
                        <v-card-text>
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-layout column>
                                    <v-layout wrap justify-center row>
                                        <v-flex xs6 class="px-3">
                                            <v-text-field v-model="form.group_name" :rules="nameRules" label="Group Name" required></v-text-field>
                                        </v-flex>
                                        <v-flex xs3 class="px-3">
                                            <v-select v-model="form.exclude_hij" :items="exclude_hijack" label="Group Type" />
                                        </v-flex>
                                    </v-layout>
                                    

                                    <v-layout v-if="form.exclude_hij=='Hijack'" align-center justify-center>
                                        <v-flex xs6>
                                            <v-subheader class="pl-0">Hijack Score Setting</v-subheader>
                                            <v-slider v-model="form.hijack_setting" thumb-label="always" min="0" max="99"></v-slider>
                                        </v-flex>
                                    </v-layout>
                                    
                                    
                                </v-layout>
                            </v-form>
                        </v-card-text>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog v-model="showAreYouSure" width="500">
            <v-toolbar color="secondary" dark>
                <v-toolbar-title> Remove {{ form.group_name }} </v-toolbar-title> <v-spacer></v-spacer> <v-icon>edit</v-icon> 
            </v-toolbar>
            <v-card >
                <v-card-text>
                    <h3> Are you sure you want to delete AS Group: {{ form.group_name }}?</h3>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="green" dark @click="removeASGroup" :disabled="loading3"> Yes, delete</v-btn>
                    <v-progress-circular v-if="loading3" indeterminate color="white"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <v-btn class="red" dark @click="showAreYouSure=false"> No, close </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import downloadcsv from 'vue-json-csv';
import info from '../../shared/operational/infopopout.vue';
import { findParentComponentByName } from '../utils/findParent.js'
import { API, graphqlOperation } from 'aws-amplify';
import OldRules from './oldRules.vue';


export default {
    name: 'as-groups',
    components: {
    downloadcsv,
    info,
    OldRules
},
    data () {
        return {
            loading: false,
            organisation: 'Organisation',
            username: 'User',
            id: null,
            orgASGroups: [],
            userASGroups: [],
            nameRules: [ v => /^[^"]*$/.test(v) || 'No double-quotes allowed' ],
            showOrgGroups: false,
            showUserGroups: false,
            showEdit: false,
            addType: 'organisation',
            edType: 'Add',
            exclude_hijack: [
                'Hijack',
                'Exclude'
            ],
            form: {
                group_name: '',
                exclude_hij: 'Exclude',
                hijack_setting: 0
            },
            rowsPerPageItems: [10, 20, 50, 100],
            pagination: {
                rowsPerPage: 10
            },
            rowsPerPageItems2: [10, 20, 50, 100],
            pagination2: {
                rowsPerPage: 10
            },
            ASGroupHeaders: [
                { text: 'AS Group Name', ad_text:'Name given to the group, for housekeeping', value: 'group_name', align:'centre'},
                { text: 'Group Type', ad_text:'Either \'Hijack\' or \'Exclude\'. Hijack will manipulate hijack scores of alerts involving ASes in the group; Exclude will omit alerts from appearing in BGP Spotlight.', value: 'exclude_hij', align:'centre'},
                { text: 'Hijack Setting', ad_text:'If group type is Hijack, the hijack score alerts will receive if ownership moves between ASes in the group', value: 'hijack_setting', align:'centre'},
                { text: 'Actions', ad_text:'Edit or delete the AS Group', align:'centre', sortable: false}
            ],
            showAreYouSure: false,
            loading3: false,
            msgColor: 'success',
            message: '',
            displayMessage: false
        };
    },
    mounted () {
    },
    beforeMount() {  
        let app = findParentComponentByName(this, 'app')
        app.checkSignedIn()
        
        try {
            this.organisation = this.$store.state.user.organisation;
            this.username = this.$store.state.user.username;
        } catch (err) {
            console.log(err)
            location.reload()
        }

        this.getOrgGroups();
        this.getUserGroups();
    },
    methods: {
        clearMessage: function () {
            this.displayMessage = false;
            this.message = "";

        },
        routeNewWindow: async function (input) {
            let routeData = this.$router.resolve({name: input});
            window.open(routeData.href, '_blank');
        },
        clickGroup: async function (item, type) {

            this.addType = type;
            this.clearMessage();

            if (item == 'Click here to add group') {
                this.edType = "Add"
                this.valid = false;
                this.form.group_name = '';
                this.form.exclude_hij = 'Exclude';
                this.form.hijack_setting = 0
                this.showEdit = true;
            } else {
                this.edType = "Edit"
                //this.valid = false;
                this.form.group_name = item.group_name;
                this.form.exclude_hij = item.exclude_hij;
                this.form.hijack_setting = item.hijack_setting;
                this.showEdit = true;
            }
        },
        prepRemoveGroup: async function (item, type) {
            this.addType = type;
            this.form = item;
            this.showAreYouSure = true;
        },
        removeASGroup: async function () {
            this.loading3 = true;

            if (this.addType == "user") {
                var p_user = this.$store.state.user.username;
            } else {
                var p_user = 'whole_organisation';
            }

            try {
                var query = `mutation deleteASNGroup {
                    deleteASNGroup (
                        p_group_name: "` + this.form.group_name + `",
                        p_organisation: "` + this.organisation + `",
                        p_user: "` + p_user + `"
                    ) {
                        asn
                    }                
                }`;
                
                const response = await API.graphql(graphqlOperation(query));
                var responseMessage = response.data.deleteASNGroup
                console.log(responseMessage)

                if (!responseMessage) {
                    this.msgColor = 'success';
                    this.message = "Successfully deleted " + this.form.group_name;
                } else {
                    this.msgColor = 'red';
                    this.message = "Error deleting " + this.form.group_name;
                }
            } catch (e) {
                console.log(e)
                this.message = "Error deleting " + this.form.group_name;
            }

            if (this.addType == "user") {
                this.getUserGroups();
            } else {
                this.getOrgGroups();
            }
            this.loading3 = false;
            this.showAreYouSure = false;
            this.displayMessage = true;


        },
        getOrgGroups: async function () {
            this.loading = true;

            var query = `query getASNGroups {
                getASNGroups (
                    p_organisation: "` + this.organisation + `",
                    p_user: "whole_organisation"
                ) {
                    group_name,
                    exclude,
                    hijack_setting
                }
            }`;

            const groupData = await API.graphql(graphqlOperation(query));
            console.log(groupData)
            var groups = groupData.data.getASNGroups;
            console.log(groups)

            if ( !groups ) {
                this.orgASGroups = []
                this.$store.commit("setOrgASGroups", []);
                this.loading = false
                this.showOrgGroups = true
            } else if ( groups.length == 0 ) {
                this.orgASGroups = []
                this.$store.commit("setOrgASGroups", []);
                this.loading = false
                this.showOrgGroups = true
            } else {
                for (var i = 0 ; i < groups.length ; i++ ) {
                    groups[i].exclude_hij = groups[i].exclude == 1 ? 'Exclude' : 'Hijack' //if 1, its hijack score based else it's exclusion based
                }
                this.orgASGroups = groups;
                this.$store.commit("setOrgASGroups", groups);
                this.loading = false;
                this.showOrgGroups = true
            }

        },
        getUserGroups: async function () {
            this.loading2 = true;

            var query = `query getASNGroups {
                getASNGroups (
                    p_organisation: "` + this.organisation + `",
                    p_user: "` + this.username + `"
                ) {
                    group_name,
                    exclude,
                    hijack_setting
                }
            }`;

            const groupData = await API.graphql(graphqlOperation(query));
            console.log(groupData)
            var groups = groupData.data.getASNGroups;
            console.log(groups)

            if ( !groups ) {
                this.userASGroups = []
                this.$store.commit("setUserASGroups", []);
                this.loading2 = false
                this.showUserGroups = true
            } else if ( groups.length == 0 ) {
                this.userASGroups = []
                this.$store.commit("setUserASGroups", []);
                this.loading2 = false
                this.showUserGroups = true
            } else {
                for (var i = 0 ; i < groups.length ; i++ ) {
                    groups[i].exclude_hij = groups[i].exclude == 1 ? 'Exclude' : 'Hijack' //if 1, its hijack score based else it's exclusion based
                }
                this.userASGroups = groups;
                this.$store.commit("setUserASGroups", groups);
                this.loading2 = false;
                this.showUserGroups = true
            }

        },
        editASGroup: async function() {
            if (this.$refs.form.validate()) {
                
                if (this.addType == "user") {
                    var p_user = this.$store.state.user.username;
                } else {
                    var p_user = "whole_organisation"
                }
                
                if (this.form.group_name != '') {
                    this.form.group_name = this.form.group_name.split('"').join('')
                    this.form.group_name = this.form.group_name.split("'").join("")
                }

                var exclude = this.form.exclude_hij == 'Hijack' ? 0 : 1;

                var query = `mutation updateASNGroup { updateASNGroup (
                    p_group_name: "` + this.form.group_name + `",
                    p_organisation: "` + this.organisation + `",
                    p_user: "` + p_user + `",
                    p_exclude: ` + exclude + `,
                    p_hijack_setting: ` + this.form.hijack_setting + `
                ) {asn}}`

                console.log(query);
                const updateGroupSettings = await API.graphql(graphqlOperation(query));
                console.log(updateGroupSettings);
                var responseMessage = updateGroupSettings.data.updateASNGroup;
                
                // EDIT THIS
                if (!responseMessage) {
                    this.msgColor = 'success';
                    this.message = "Successfully " + this.edType + "ed " + this.form.group_name;
                } else {
                    this.msgColor = 'red';
                    this.message = "Error " + this.edType + "ing " + this.form.group_name;
                }

                if (this.addType == "user") {
                    this.getUserGroups();
                } else {
                    this.getOrgGroups();
                }
                this.showEdit = false;

                this.displayMessage = true;
            }

        },
        
    }
    };
    </script>
